import React from 'react';

import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {
    fetchTagModerationQualificationWarningLevel,
    resetTagModerationQualificationWarningLevel
} from "../../../creators/tagModerationQualificationWarning";

import {Link} from "react-router-dom";
import createLink from "../../../libs/createLink";

const alertWarningStyle={
    background: "#fff3cd",
    color: "#664d03",
    borderBottomColor : "#ffecb5",
    padding : "12px",
}
const alertWarningLinkStyle={
    color: "#664d03",

}

const alertDangerStyle={
    background: "#f8d7da",
    color: "#842029",
    borderBottomColor : "#f5c2c7",
    padding : "12px",
}
const alertDangerLinkStyle={
    color: "#842029",
}


class TagModerationQualificationWarning extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchTagModerationQualificationWarningLevel();
    }

    componentWillUnmount() {
        this.props.resetTagModerationQualificationWarningLevel();
    }

    render() {

        let arrayAlertStyle = [
            {},
            alertWarningStyle,
            alertDangerStyle
        ];
        let arrayAlertLinkStyle = [
            {},
            alertWarningLinkStyle,
            alertDangerLinkStyle
        ];
        let arrayAlertMessage = [
            "",
            "Le nombre de nouveaux médias non vérifiés est élevé, pouvez-vous y accorder quelques minutes ?",
            <>La quantité de nouveaux médias non vérifiés est devenue <strong>critique</strong>, merci d’intervenir dès que possible !</>
        ];
        let level = this.props?.tagModerationQualificationWarningLevel?.level || 0;
        //level = 1;
        return this.props.tagModerationQualificationWarningLevelInitialized && level !== 0 ? (
            <div className="alert-bar" style={arrayAlertStyle[level]}>
                <Link to={createLink("tagModerationQualifications")} style={arrayAlertLinkStyle[level]}>
                    <span className="alert-bar-message">
                        {arrayAlertMessage[level]}
                    </span>
                </Link>
            </div>
        ) : null;
    }
}

const mapStateToProps = (state, props) => {

    return {
        tagModerationQualificationWarningLevel: state.tagModerationQualificationWarningLevel.data,
        tagModerationQualificationWarningLevelLoading: state.tagModerationQualificationWarningLevel.loading,
        tagModerationQualificationWarningLevelInitialized: state.tagModerationQualificationWarningLevel.initialized,
    }
};


const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchTagModerationQualificationWarningLevel,
    resetTagModerationQualificationWarningLevel,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TagModerationQualificationWarning);
